import api from './api';
import { AxiosRequestConfig } from 'axios';
export interface CaixaEntradaModel {
  processo: string;
  nome?: string;
  infoComplementar?: string;
  informacaoComplementarComBarraN?: string;
  contrato?: string;
  fornecedor?: string;
  responsavel?: string;
  dataInicio?: Date;
  dataConclusaoEstimada?: Date;
  link?: string;
  dataIniciaoString: string;
}
export const getAllCaixaEntrada = (
  usuarioId: string,
  axiosConfig?: any 
) =>
  api.get<CaixaEntradaModel[]>(
    `caixaEntrada/${usuarioId}`,
    {}, 
    axiosConfig 
  );

export const processos = [
  {
    text: 'Contrato',
    value: 'Contrato',
  },
  {
    text: 'Pendência Documental',
    value: 'Pendência Documental',
  },
  {
    text: 'Seguros e Garantias',
    value: 'Seguros e Garantias',
  },
  {
    text: 'Medição',
    value: 'Medição',
  },
  {
    text: 'Correção de Planilha de Quantidade',
    value: 'Correção de Planilha de Quantidade',
  },
  {
    text: 'Autorização e Pagamento',
    value: 'Autorização e Pagamento',
  },
  {
    text: 'Encerramento',
    value: 'Encerramento',
  },
  {
    text: 'Correspondência',
    value: 'Correspondência',
  },
  {
    text: 'Pré-Contratação',
    value: 'Pré-Contratação',
  },
  {
    text: 'SAS',
    value: 'SAS',
  },
];
